{
	"ariaActiveLutName": "Active LUT Name",
	"ariaAdjustmentControls": "adjustment controls",
	"ariaAutoVerticalTransform": "Auto Vertical Transform",
	"ariaChooseLutFile": "Choose LUT File",
	"ariaEditorRightPanelGroup": "Editor Right Panel Group",
	"ariaOpenPhotoColorProfileList": "Open Photo Color Profile List",
	"ariaOpenPhotoWhiteBalancePresetList": "Open Photo White Balance Preset List",
	"ariaPhotoColorProfileList": "Photo Color Profile List",
	"ariaPhotoWhiteBalancePresetList": "Photo White Balance Preset List",
	"ariaRemoveLut": "Remove LUT",
	"ariaSelectColorProfile": "Select Color Profile",
	"ariaSelectWhiteBalancePreset": "Select White Balance Preset",
	"ariaToggleLensChromaticAberrationCorrection": "Toggle Lens Chromatic Aberration Correction",
	"ariaToggleLensDistortionCorrection": "Toggle Lens Distortion Correction",
	"ariaToggleLensProfileCorrections": "Toggle Lens Profile Corrections",
	"ariaToggleLensVignetteCorrection": "Toggle Lens Vignette Correction",
	"auto": "Auto",
	"autoVertical": "Auto Vertical",
	"bluePrimary": "Blue Primary",
	"chooseLutFile": "Choose LUT File",
	"colorProfile": "Color Profile:",
	"correctLensChromaticAberration": "Correct lens chromatic aberration",
	"correctLensDistortion": "Correct lens distortion",
	"correctLensVignette": "Correct lens vignette",
	"defringe": "Defringe",
	"colorProfileAppleProraw": "Apple ProRAW",
	"colorProfileColor": "Color",
	"colorProfileCustom": "Custom",
	"colorProfileMonochrome": "Monochrome",
	"colorProfileStandard": "Standard",
	"colorProfileStandardBw": "Standard B&W",
	"cubeLut": "CUBE LUT",
	"enableProfileCorrections": "Enable Profile Corrections",
	"grain": "Grain",
	"greenPrimary": "Green Primary",
	"lutActive": "Active",
	"noiseReduction": "Noise Reduction",
	"panelAiColorMatch": "AI Color Match",
	"panelBasic": "Basic",
	"panelBw": "B&W",
	"panelCalibration": "Calibration",
	"panelColorGrading": "Color Grading",
	"panelCurves": "Curves",
	"panelDetail": "Detail",
	"panelEffects": "Effects",
	"panelHistogram": "Histogram",
	"panelHsl": "HSL",
	"panelLensCorrection": "Lens Correction",
	"panelLut": "LUT",
	"panelPointColor": "Point Color",
	"panelTransform": "Transform",
	"redPrimary": "Red Primary",
	"remove": "Remove",
	"sectionBlueHue": "Blue Hue",
	"sectionBlueSaturation": "Blue Saturation",
	"sectionGrainAmount": "Grain Amount",
	"sectionGrainRoughness": "Grain Roughness",
	"sectionGrainSize": "Grain Size",
	"sectionGreenDefringeAmount": "Green Defringe Amount",
	"sectionGreenHue": "Green Hue",
	"sectionGreenSaturation": "Green Saturation",
	"sectionPurpleDefringeAmount": "Purple Defringe Amount",
	"sectionRedHue": "Red Hue",
	"sectionRedSaturation": "Red Saturation",
	"sectionVignetteAmount": "Vignette Amount",
	"sectionVignetteFeather": "Vignette Feather",
	"sectionVignetteHighlights": "Vignette Highlights",
	"sectionVignetteMidpoint": "Vignette Midpoint",
	"sectionVignetteRoundness": "Vignette Roundness",
	"sliderAmount": "Amount",
	"sliderAspect": "Aspect",
	"sliderBlacks": "Blacks",
	"sliderClarity": "Clarity",
	"sliderColor": "Color",
	"sliderContrast": "Contrast",
	"sliderDehaze": "Dehaze",
	"sliderDistortion": "Distortion",
	"sliderExposure": "Exposure",
	"sliderFeather": "Feather",
	"sliderGreenHue": "Green Hue",
	"sliderHighlights": "Highlights",
	"sliderHorizontal": "Horizontal",
	"sliderHue": "Hue",
	"sliderLuminance": "Luminance",
	"sliderMidpoint": "Midpoint",
	"sliderPurpleHue": "Purple Hue",
	"sliderRotate": "Rotate",
	"sliderRoughness": "Roughness",
	"sliderRoundness": "Roundness",
	"sliderSaturation": "Saturation",
	"sliderScale": "Scale",
	"sliderShadows": "Shadows",
	"sliderSharpening": "Sharpening",
	"sliderSize": "Size",
	"sliderStrength": "Strength",
	"sliderTemp": "Temp",
	"sliderTexture": "Texture",
	"sliderTint": "Tint",
	"sliderVertical": "Vertical",
	"sliderVibrance": "Vibrance",
	"sliderVignette": "Vignette",
	"sliderWhites": "Whites",
	"sliderXOffset": "X Offset",
	"sliderYOffset": "Y Offset",
	"toastFringeColorInvalid": "Cannot set the purple or green fringe color. Please sample a representative fringe color again.",
	"toastUnableToImportLut": "Unable to import LUT",
	"toastWhiteBalanceTooDark": "Cannot set white-balance here. Please click on a brighter neutral area.",
	"toastWhiteBalanceTooLight": "Cannot set white-balance here. Please click on a darker neutral area.",
	"tooltipLensDetectedNoCorrection": "Lens detected but auto correction unavailable",
	"unknownLens": "Unknown Lens",
	"untitledLut": "Untitled LUT",
	"vignette": "Vignette",
	"wb": "WB:",
	"wbAsShot": "As Shot",
	"wbCustom": "Custom",
	"lutNone": "None"
}
